<div class="flex flex-col h-screen bg-mainBackground">
  <div class="p-tiny pb-0">
    <app-header></app-header>
  </div>

  <div class="flex flex-1 overflow-hidden">
    <!-- Sidebar -->
    <div class="p-tiny sidebar-container">
      <app-sidebar></app-sidebar>
    </div>

    <!-- Main Content -->
    <div class="flex-1 h-full main-container p-tiny overflow-y-auto">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
